var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPerfis = function SvgPerfis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "37.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "37.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 11,
    x: 0.5,
    y: 0.5,
    fill: "url(#a)",
    fillRule: "nonzero",
    stroke: "#BEBFCB",
    rx: 2.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4,
    fill: "#498FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.491 6A.536.536 0 0 1 9 6.7c-.04.151-.64 2.308-3 2.3-2.44-.009-3-2.19-3-2.158l-.024-.1-.008-.101A.64.64 0 0 1 3.608 6zM6 3a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 6 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A79",
    d: "M7.403 6c.248.211.324.396.324.637l.002.258c.42.086.521.504.521.779v.595a.23.23 0 0 1-.228.231.23.23 0 0 1-.228-.231c0-.105.068-.193.162-.222v-.373c0-.25-.174-.454-.39-.454-.217 0-.392.203-.392.454l.001.373a.231.231 0 0 1 .162.222.23.23 0 0 1-.228.231.229.229 0 0 1-.22-.17l-.008-.061v-.595c0-.275.1-.693.52-.779l.002-.258c0-.336-.159-.41-.447-.637h.447zM4.885 6c-.195.465-.29.79-.286.975.006.242.06.554.32.628a.317.317 0 0 1 .23-.098c.178 0 .322.146.322.326 0 .18-.144.326-.322.326a.323.323 0 0 1-.308-.233c-.337-.086-.591-.394-.591-.95 0-.442.095-.767.286-.974h.35zm.17 0s1.787 0 1.787.008c-.075.435-.372.972-.893 1.612-.523-.642-.82-1.182-.894-1.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A7B8E",
    d: "M23 7a1 1 0 0 1 0 2H13a1 1 0 0 1 0-2h10zm-4-4a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2h6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "nonzero",
    stroke: "#BEBFCB",
    d: "M18.17 25.5l.02-.704c.061-.351.26-.663.55-.868.292-.205.653-.285.916-.23h.483a2.5 2.5 0 0 1 .577-3.092l.519-.442a2.077 2.077 0 0 1 2.277-.277 1.5 1.5 0 0 1 1.378-1.016l2.394-.068h.035c.061 0 .122.003.182.01L27.5 16.12a1.62 1.62 0 0 0-1.62-1.62H2.12A1.62 1.62 0 0 0 .5 16.12v7.76c0 .895.725 1.62 1.62 1.62h16.05z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 20,
    r: 4,
    fill: "#498FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.491 20a.536.536 0 0 1 .509.7c-.04.151-.64 2.308-3 2.3-2.44-.009-3-2.19-3-2.158l-.024-.1-.008-.101a.64.64 0 0 1 .64-.641zM6 17a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 6 17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A79",
    d: "M7.403 20c.248.211.324.396.324.637l.002.258c.42.086.521.504.521.779v.595a.23.23 0 0 1-.228.231.23.23 0 0 1-.228-.231c0-.105.068-.193.162-.222v-.373c0-.25-.174-.454-.39-.454-.217 0-.392.203-.392.454l.001.373a.231.231 0 0 1 .162.222.23.23 0 0 1-.228.231.229.229 0 0 1-.22-.17l-.008-.061v-.595c0-.275.1-.693.52-.779l.002-.258c0-.336-.159-.41-.447-.637h.447zm-2.518 0c-.195.465-.29.79-.286.975.006.242.06.554.32.628a.317.317 0 0 1 .23-.098c.178 0 .322.146.322.326 0 .18-.144.326-.322.326a.323.323 0 0 1-.308-.233c-.337-.086-.591-.394-.591-.95 0-.442.095-.767.286-.974h.35zm.17 0s1.787 0 1.787.008c-.075.435-.372.972-.893 1.612-.523-.642-.82-1.182-.894-1.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A7B8E",
    d: "M19.772 21c-.365.467-.509 1.133-.432 2H13a1 1 0 0 1 0-2h6.772zM19 17a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2h6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#498FFF",
    d: "M31.205 24.694h-1.131a4.199 4.199 0 0 0-.322-.789l.786-.789a.72.72 0 0 0 0-1.01l-.786-.788a.721.721 0 0 0-1.006 0l-.786.789a4.884 4.884 0 0 0-.786-.324V20.71a.709.709 0 0 0-.707-.71h-1.045a.706.706 0 0 0-.715.71v1.105a5.12 5.12 0 0 0-.786.323l-.786-.789a.729.729 0 0 0-1.013 0l-.786.79a.704.704 0 0 0 0 1.009l.786.789a4.199 4.199 0 0 0-.322.789h-1.093a.706.706 0 0 0-.707.718v1.073a.712.712 0 0 0 .707.718h1.14c.077.274.185.539.322.789l-.786.789a.704.704 0 0 0 0 1.01l.786.788a.729.729 0 0 0 1.014 0l.785-.788c.253.129.516.237.786.323v1.136c0 .397.32.718.715.718h1.077a.706.706 0 0 0 .707-.718v-1.2c.27-.084.534-.192.786-.323l.786.79a.721.721 0 0 0 1.006 0l.785-.79a.72.72 0 0 0 0-1.01l-.786-.788c.137-.25.245-.515.322-.79h1.132a.717.717 0 0 0 .715-.717v-1.01a.72.72 0 0 0-.794-.75zm-5.249 3.117a1.882 1.882 0 0 1-1.878-1.886c0-1.041.841-1.885 1.878-1.885 1.038 0 1.878.844 1.878 1.885s-.84 1.886-1.878 1.886z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerfis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/perfis.cc63feb3.svg";
export { ForwardRef as ReactComponent };